<template>
  <!-- DATETIME -->
  <div class="event-datetime-wrapper  is-block" v-if="event">

    <div style="position: relative; padding-top: 2px">
      <!-- <div class="section-margin"> -->
        <!-- <p class="is-24x24">
          <img src="@/assets/svg/calendar-clock.svg" />
        </p>-->
        <span class="icon has-text-grey-dark is-medium" style="position: absolute; left: 12px; top: 0;">
          <i class="mdi mdi-calendar-clock mdi-24px"></i>
        </span>

        <!-- <span class="has-text-weight-semibold has-text-black-bis ml-half">{{ title | capitalize}}</span> -->
      <!-- </div> -->

      <!-- MULTIIPLE SHOWTIMES -->
      <div class="is-rail has-gradient-mask py-0 is-size-15px" style="margin-left: 52px; width: calc(100vw - 52px)">
        <!-- showtimes array -->
        <div
          class="is-white date-card is-borderless"
          style="opacity: 1"
          v-for="(date, ind) in event.data.eventShowtimes"
          :key="ind"
        >
          <time
            class="is-block has-text-weight-medium"
            :datetime="date.startTime | toHTMLDate"
          >{{ eventDateStartTime(date) }}</time>
          <time
            class="is-inline-block"
            :datetime="date.startTime | toHTMLDateTime"
          >{{ date.startTime | toTime }}</time>
          <time
            v-if="$options.filters.toTime(date.startTime) !== $options.filters.toTime(date.endTime)"
            class="is-inline-block"
            :datetime="date.endTime | toHTMLDateTime"
          >&nbsp;-&nbsp;{{ date.endTime | toTime }}</time>
        </div>

        <div class="is-rail-end-gap"></div>
      </div>
    </div>
  </div>
  <!-- ./DATETIME -->
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedDate: {}
    };
  },
  methods: {
    eventDateStartTime(datetime) {
      let date = "";
      // if same day
      if (datetime.startTime.getDate() === datetime.endTime.getDate()) {
        date = `${datetime.startTime.getDate()}
            ${this.$t(`monthNames.${datetime.startTime.getMonth()}`)} ${this.$t(`dayNames.${datetime.startTime.getDay()}`)}`;
      } else {
        // if not same day
        date = `${datetime.startTime.getDate()}
            ${this.$t(
              `monthNames.${datetime.startTime.getMonth()}`
            )} ${this.$t(`dayNames.${datetime.startTime.getDay()}`)} - 
            ${datetime.endTime.getDate()} ${this.$t(
          `monthNames.${datetime.endTime.getMonth()}`
        )} ${this.$t(`dayNames.${datetime.endTime.getDay()}`)}`;
      }
      return date;
    },
    setSelectedDate(date) {
      console.log("select date");
      this.selectedDate = date;
    }
  }
};
</script>

<style lang="scss" scoped>
.date-card.is-borderless {
  // padding-top: 4px;
}

.date-card.is-borderless + .date-card.is-borderless {
  border-left: 1px solid $grey-lighter;
  // padding-left: 0.75rem !important;
}


.is-rail .date-card {
  position: relative;
  padding: 0 0.75rem;
  display: inline-block;
//   margin: 0 0.375rem;
//   opacity: 0.8;
}
.date-card.is-active {
  border: 1px solid $info !important;
  opacity: 1;
  // padding-right: 1.25rem !important;
}

// .date-card .icon.is-bottom-right {
//   position: absolute;
//   bottom: 6px;
//   right: 6px;
// }

.is-rail .date-card:first-child {
  padding-left: 0;
  // border-radius: 24px;
}

.is-rail .date-card.has-border {
  border: 1px solid $grey-lighter;
  border-radius: 4px;
}
/*
*  END: RAIL (Horizontal Scroll)
*/
/* .event-datetime-wrapper .media + .media {
  border-top: 0 !important;
  margin-top: 0.5rem !important;
  padding-top: 0.5rem !important;
} */
</style>